// import React from 'react'
import React, { useEffect, useState } from "react";
import ReactTable from "components/common/table/ReactTable2";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import AddIcon from "@mui/icons-material/Add";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";

import { SEC_SUBDIV, GET_SUBDIVISION_LIST } from '../../@jumbo/constant/ActionTypes';
import { SET_TENANT } from "@jumbo/constant/ActionTypes";

import { Buttons } from "../Button";
import SearchInput from "../SearchInput";
import AmountItems from "../AmountItems/AmountItems";
import {
  getTenantList,
  getCurrTenantDetail,
  deleteUser,
  getAllTenantsListForSEC,
} from "redux/actions/tenant";
import { getSubdivisionList, connectDisconnectSub } from '../../redux/actions/SubDivision';
import ConfirmDltDialog from "../ConfirmDltDialog";
import AddConfirmDialog from "../AddConfirmDialog";
import ConnectTennantDialog from "../ConnectTennantDialog";

export default function Tenants() {
  const { users } = useSelector(({ TENANT }) => TENANT);
  const { allUsers } = useSelector(({ SUBDIVISION }) => SUBDIVISION);
  const userProfile = useSelector(store => store?.USERPROFILE?.currentuser?.detail);
  const [selectedUser, setSelectedUser] = useState({ first_name: "" });
  const [openConfirmDialog, setOpenConfirmDialog] = useState(false);
  const [openConfirmDltDialog, setopenConfirmDltDialog] = useState(false)
  const [searchValue, setSearchValue] = useState("");
  const [activePage, setActivePage] = useState(1);
  const [activePerPage, setActivePerPage] = useState(10);
  const [openTennant, setOpenTenant] = useState(false);
  const [selectedTenantId, setSelectedTenantId] = useState("");
  const onCloseTennantDialog = () => setOpenTenant(false);

  const dispatch = useDispatch();
  let navigate = useNavigate();
  let user_type = 3;

  const columns = [
    {
      id: "id",
      accessor: "id",
      title: "Tenant ID",
      width: "8%",
      tag: true,
      sortable: true,
    },
    {
      id: "first_name",
      accessor: "first_name",
      title: "Full Name",
      Component: ({ row }) => { return `${row?.first_name || ''}   ${row?.last_name || ''}` }
    },
    {
      id: "mobile",
      accessor: "mobile",
      title: "Phone",
      Component: ({ row }) => row?.mobile || "-"
    },
    {
      id: "email",
      accessor: "email",
      title: "Email",
      minWidth: 170,
      Component: ({ row }) => row?.email || "-"
    },
    {
      id: "firm_name",
      accessor: "firm_name",
      title: "Tenant Name",
      sortable: true,
      Component: ({ row }) => row?.firm_name || "-"
    },
    {
      id: "numberOfLicenses",
      accessor: "numberOfLicenses",
      title: `No. of licenses`,
      sortable: true,
      Component: ({ row }) => {
        return (
          !row.number_of_licenses ? "-" : `${!!row ? row.number_of_licenses ? row.number_of_licenses.used : null : null} / ${!!row ? row.number_of_licenses ? row.number_of_licenses.assigned : null : null}`
        );
      }
    },
    {
      id: "status",
      accessor: "status",
      title: "Status",
      sortable: true,
      Component: ({ row }) => {
        return (
          <>
            <FiberManualRecordIcon style={{ fontSize: "0.5rem", color: row.status === 1 ? 'rgb(95, 170, 176)' : 'rgb(225, 108, 108)', marginRight: '5px' }} />
            {row.status === 1 ? `Active` : "Disabled"}
          </>
        )
      }
    },
    {
      id: 'id',
      accessor: 'id',
      title: 'Actions',
      Component: ({ row }) => {
        return (
          <>
            {userProfile?.user_type !== 2 ? (<>
              <span className="text-[#4892c3] cursor-pointer" onClick={() => handleEdit(row._id)} >
                Edit
              </span>
              <button className="text-[#e17070] ml-2 cursor-pointer" onClick={() => handleUserDelete(row)}>
                Delete
              </button>
            </>) : (
              <span className="text-[#4892c3] cursor-pointer" onClick={() => onHandleClickMore(row._id)} >
                More
              </span>
            )}
          </>
        );
      }
    }
  ]

  const [sortingOption, setSortingOption] = useState({ columnName: 'id', direction: 'desc' });

  useEffect(() => {
    if (userProfile && userProfile?.user_type === 2) {
      dispatch(getAllTenantsListForSEC(sortingOption?.columnName,
        sortingOption?.direction,
        searchValue,
        activePage,
        activePerPage))
    } else if (userProfile && userProfile?.user_type !== 2) {
      dispatch(
        getTenantList(
          user_type,
          sortingOption?.columnName,
          sortingOption?.direction,
          searchValue,
          activePage,
          activePerPage
        )
      );
    }
  }, [sortingOption, activePage, activePerPage, dispatch, userProfile, searchValue]);

  useEffect(() => {
    // dispatch(getSubdivisionList());
    localStorage.removeItem("sec_subdiv_id");
    dispatch({ type: SEC_SUBDIV, payload: "" })
  }, []);

  const onHandleClickMore = async (id) => {
    dispatch({ type: GET_SUBDIVISION_LIST, payload: [] })
    setSelectedTenantId(id)
    await dispatch(getSubdivisionList(id));
    setOpenTenant(true);
  }

  const handleEdit = (id) => {
    dispatch({ type: SET_TENANT, payload: [] });
    dispatch(getCurrTenantDetail(id));
    navigate(`/app/Tenants/EditTenant/${id}`);
  };

  const addTenant = () => {
    navigate(`/app/Tenants/AddTenant/`);
    dispatch({ type: SET_TENANT, payload: null });
  };

  const handleUserDelete = (user) => {
    setSelectedUser(user);
    setopenConfirmDltDialog(true);
  };

  const handleCancelDelete = () => {
    setopenConfirmDltDialog(false);
  };

  const handleConfirmDelete = () => {
    setopenConfirmDltDialog(false);
    dispatch(deleteUser(selectedUser._id, { setAddDialog: () => setOpenConfirmDialog(true) },
      () => {
        if (userProfile && userProfile?.user_type === 2) {
          return dispatch(getAllTenantsListForSEC(sortingOption?.columnName,
            sortingOption?.direction,
            searchValue,
            activePage,
            activePerPage))
        } else if (userProfile && userProfile?.user_type !== 2) {
          return dispatch(
            getTenantList(
              user_type,
              sortingOption?.columnName,
              sortingOption?.direction,
              searchValue,
              activePage,
              activePerPage
            )
          );
        }
      }))
  };

  const onSearch = (searchValue) => {
    setSearchValue(searchValue);
  };

  const submitSearch = (e) => {
    e.preventDefault();
    setSearchValue(searchValue);
    if (userProfile && userProfile?.user_type === 2) {
      return dispatch(getAllTenantsListForSEC(sortingOption?.columnName,
        sortingOption?.direction,
        searchValue,
        activePage,
        activePerPage))
    } else if (userProfile && userProfile?.user_type !== 2) {
      return dispatch(
        getTenantList(
          user_type,
          sortingOption?.columnName,
          sortingOption?.direction,
          searchValue,
          activePage,
          activePerPage
        )
      );
    }
  };

  const clearSearch = (e) => {
    e.preventDefault();
    setSearchValue("");
    if (userProfile && userProfile?.user_type === 2) {
      return dispatch(getAllTenantsListForSEC(sortingOption?.columnName,
        sortingOption?.direction,
        searchValue,
        activePage,
        activePerPage))
    } else if (userProfile && userProfile?.user_type !== 2) {
      return dispatch(
        getTenantList(user_type, sortingOption?.columnName,
          sortingOption?.direction, "", activePage, activePerPage)
      );
    }
  };

  const changePerPage = (activePerPage) => {
    // e.preventDefault();
    setActivePage(1);
    setActivePerPage(activePerPage);
    if (userProfile && userProfile?.user_type === 2) {
      return dispatch(getAllTenantsListForSEC(sortingOption?.columnName,
        sortingOption?.direction,
        searchValue,
        // activePage,
        activePerPage))
    } else if (userProfile && userProfile?.user_type !== 2) {
      return dispatch(
        getTenantList(
          user_type,
          sortingOption?.columnName,
          sortingOption?.direction,
          searchValue,
          // activePage,
          activePerPage
        )
      );
    }
  };

  const handlePageChange = (pageNumber) => {
    setActivePage(pageNumber);
    if (userProfile?.user_type === 2) {
      dispatch(getAllTenantsListForSEC(
        sortingOption?.columnName,
        sortingOption?.direction,
        searchValue,
        pageNumber,
        activePerPage
      ));
    } else {
      dispatch(getTenantList(
        user_type,
        sortingOption?.columnName,
        sortingOption?.direction,
        searchValue,
        pageNumber,
        activePerPage
      ));
    }
  };


  const handleCancelConfirm = () => {
    setOpenConfirmDialog(false)
    if (userProfile && userProfile?.user_type === 2) {
      return dispatch(getAllTenantsListForSEC(sortingOption?.columnName,
        sortingOption?.direction,
        searchValue,
        activePage,
        activePerPage))
    } else if (userProfile && userProfile?.user_type !== 2) {
      return dispatch(
        getTenantList(
          user_type,
          sortingOption?.columnName,
          sortingOption?.direction,
          searchValue,
          activePage,
          activePerPage
        )
      );
    }
  }

  const handleConfirm = () => {
    setOpenConfirmDialog(false)
  }

  const onHadleConnectDisconnect = (data) => {
    const riderect = () => navigate("/app/ConnectedSubDivisions");
    dispatch(connectDisconnectSub({ ...data, tenant_id: selectedTenantId }, onCloseTennantDialog, riderect));
  }

  // const usersList = userProfile && userProfile?.user_type === 2 ? getTenantList : getAllTenantsListForSEC

  // console.log('usersList::', usersList)

  return (
    <>
      <div className="mainDiv1">
        <div className="heading-section">
          <div className="pageTitle">Tenant Table <span className="totalCount">({users && users.total ? users.total : '0'})</span></div>

          {/* Add Tenant */}

          {userProfile && userProfile?.user_type !== 2 &&
            <Buttons
              onClick={addTenant}
              addButtonnProps={true}
            >
              <AddIcon />
              Add Tenant
            </Buttons>}
        </div>

        {/* Search Section */}

        <div className='serch-section'>
          <SearchInput
            onChange={onSearch}
            searchValue={searchValue}
            onSubmit={submitSearch}
            clearSearch={clearSearch}
          />

          <AmountItems
            changePerPage={changePerPage}
            activePerPage={activePerPage}
          />
        </div>

        {/* Dynamic Table */}

        <ReactTable
          COLUMNS={columns}
          DATA={users?.userData}
          fetchData={handlePageChange}
          totalCount={users.total}
          pageSize={activePerPage}
          pageIndex={activePage}
          sortingOption={sortingOption}
          setSortingOption={setSortingOption}
          setSearchValue={setSearchValue}
        />

        {/* Delete Dialouge */}

        <ConfirmDltDialog
          open={openConfirmDltDialog}
          content={`Are you sure you want to delete ${!!selectedUser ? selectedUser.first_name : ''} ${!!selectedUser ? selectedUser.last_name : ''}?  `}
          content1={`All information about this user will be permanently deleted. `}
          btnLabels={{
            no: "No",
            Yes: "Yes",
          }}
          onClose={handleCancelDelete}
          onConfirm={handleConfirmDelete}
        />

        {/* Add confirm Dialouge */}

        <AddConfirmDialog
          open={openConfirmDialog}
          // title={`Delete Subdivision`}
          content={`Tenant was deleted successfully! `}
          btnLabels={{
            ok: "Ok",
          }}
          onClose={handleCancelConfirm}
          onConfirm={handleConfirm}
        />

        {/* Connect Tenant Dialouge */}

        <ConnectTennantDialog
          open={openTennant}
          onClose={onCloseTennantDialog}
          allUsers={allUsers}
          onHandleConnect={onHadleConnectDisconnect}
        />
      </div>
    </>
  )
}
